<template>
  <div id="integrationAPI" class="margin-subpages">
    <div class="sub-title">{{ $t("integrations.API_DOCUMENTATION") }}</div>
    <div class="line-style my-16" />
    <div class="sub-description">
      {{ $t("integrations.Reference_and_instructional") }}
    </div>
    <div class="flex mt-24">
      <div @click.prevent="gotoApiDoc" class="btn-api flex-center">
        <img
          :src="$utils('icons', 'open_in_new_white_24dp')"
          class="mr-14"
          style="widht: 20px; height: 20px"
          alt="icons_open_in_new_white_24dp"
        />
        {{ $t("integrations.Go_to_API_Doc") }}
      </div>
    </div>
    <div class="sub-title mt-32">DEVELOPMENT TOKEN</div>
    <div class="line-style my-16" />
    <div class="sub-description">
      This is your develoopment token. Your API tokens need to be treated as
      securely as any other password.
    </div>
    <div class="flex mt-24">
      <div class="flex-center" v-if="!apiKeyDev.generate">
        <div @click.prevent="createApiKeyDev" class="btn-api flex-center">
          <img
            :src="$utils('icons', 'key_white_24dp')"
            class="mr-12"
            style="widht: 22px; height: 22px"
            alt="icons_key_white_24dp"
          />
          {{ $t("integrations.Generate_a_Token") }}
        </div>
      </div>
      <div class="flex-center" v-else>
        <div
          @click.prevent="copyApiKeyDev"
          class="
            token-input
            flex-center
            fc-3B3B3B
            fs-18
            select-none
            cursor-pointer
          "
        >
          <div class="ellipsis" v-if="apiKeyDev.showingStatus">
            {{ apiKeyDev.token }}
          </div>
          <div class="flex select-none ellipsis" v-else>
            <span
              v-for="value in apiKeyDev.mockTaken"
              :key="value + '_key'"
              class="unicode-key mr-2"
              >●</span
            >
          </div>
        </div>
        <div
          @click.prevent="apiKeyDev.showingStatus = !apiKeyDev.showingStatus"
          class="select-none input-gray flex-mid cursor-pointer ml-12"
        >
          <img
            v-if="apiKeyDev.showingStatus"
            :src="$utils('icons', 'visibility_off_black_24dp')"
            style="widht: 22px; heigth: 22px"
            alt="icons_visibility_off_black_24dp"
          />
          <img
            v-else
            :src="$utils('icons', 'visibility_black_24dp')"
            style="widht: 22px; heigth: 22px"
            alt="icons_visibility_black_24dp"
          />
        </div>
        <div
          @click.prevent="removeApiKeyDev"
          class="input-gray flex-mid cursor-pointer ml-12 select-none"
        >
          <img
            :src="$utils('icons', 'delete_black_24dp')"
            alt="icons_delete_black_24dp"
          />
        </div>
      </div>
    </div>

    <div class="sub-title mt-32">PRODUCTION TOKEN</div>
    <div class="line-style my-16" />
    <div class="sub-description">
      This is your production token. Your API tokens need to be treated as
      securely as any other password.
    </div>
    <div class="flex mt-24">
      <div class="flex-center" v-if="!apiKeyProd.generate">
        <div @click.prevent="createApiKeyProd" class="btn-api flex-center">
          <img
            :src="$utils('icons', 'key_white_24dp')"
            class="mr-12"
            style="widht: 22px; height: 22px"
            alt="icons_key_white_24dp"
          />
          Generate a Token
        </div>
      </div>
      <div class="flex-center" v-else>
        <div
          @click.prevent="copyApiKeyProd"
          class="
            token-input
            flex-center
            fc-3B3B3B
            fs-18
            select-none
            cursor-pointer
          "
        >
          <div class="ellipsis" v-if="apiKeyProd.showingStatus">
            {{ apiKeyProd.token }}
          </div>
          <div class="flex select-none ellipsis" v-else>
            <span
              v-for="value in apiKeyProd.mockTaken"
              :key="value + '_key'"
              class="unicode-key mr-2"
              >●</span
            >
          </div>
        </div>
        <div
          @click.prevent="apiKeyProd.showingStatus = !apiKeyProd.showingStatus"
          class="select-none input-gray flex-mid cursor-pointer ml-12"
        >
          <img
            v-if="apiKeyProd.showingStatus"
            :src="$utils('icons', 'visibility_off_black_24dp')"
            style="widht: 22px; heigth: 22px"
            alt="icons_visibility_off_black_24dp"
          />
          <img
            v-else
            :src="$utils('icons', 'visibility_black_24dp')"
            style="widht: 22px; heigth: 22px"
            alt="icons_visibility_black_24dp"
          />
        </div>
        <div
          @click.prevent="removeApiKeyProd"
          class="input-gray flex-mid cursor-pointer ml-12 select-none"
        >
          <img
            :src="$utils('icons', 'delete_black_24dp')"
            alt="icons_delete_black_24dp"
          />
        </div>
      </div>
    </div>

    <div class="sub-title mt-32">{{ $t("integrations.API_LOG") }}</div>
    <div class="line-style my-16" />
    <div class="sub-description">
      {{ $t("integrations.A_log_of_API_activity") }}
    </div>
    <div id="log_table_api" class="mt-12" style="min-height: 720px">
      <el-table
        empty-text="No API activity recorded"
        :data="apiLogs.results"
        v-if="!apiLogs.error"
        style="width: 100%"
      >
        <el-table-column label="Date" width="160">
          <template slot-scope="scope">
            <div>
              <div class="fs-14 fc-4A4A4A fw-700">{{ scope.row.date }}</div>
              <div class="fs-14 fc-4A4A4A">{{ scope.row.time }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="API Operation" width="490">
          <template slot-scope="scope">
            <div
              :class="`text-oeration ${
                scope.row.status == 'Failed' ? 'red' : ''
              }`"
            >
              <span class="fc-4A4A4A fs-14">{{ scope.row.operation }}</span>
              <div style="display: none">{{ scope.row.logStreamName }}</div>
              <div style="display: none">{{ scope.row.timestamp }}</div>
              <div style="display: none">{{ scope.row.eventId }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="120" label="Status">
          <template slot-scope="scope">
            <div class="">
              <span class="fc-4A4A4A fs-14">{{ scope.row.status }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="120" label="Deployment">
          <template slot-scope="scope">
            <div class="">
              <span class="fc-4A4A4A fs-14">{{ scope.row.deployment }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div
        class="flex-center pagination mt-10 pb-40"
        v-if="!apiLogs.error && apiLogs.results.length"
      >
        <el-pagination
          @current-change="pageCurrentLogChange"
          :current-page="apiLogs.page"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next"
          :total="apiLogs.data.length"
        ></el-pagination>
        <span class="results-status">
          {{ apiLogs.results.length > 10 ? 10 : apiLogs.results.length }}
          results from
          {{
            $utils("addCommasInNumber", apiLogs.data ? apiLogs.data.length : 0)
          }}
          results
        </span>
      </div>
      <div
        class="center mt-10 mb-40 pt-10 pb-40"
        v-if="!apiLogs.error && !apiLogs.results.length"
      >
        <loading-even></loading-even>
      </div>
      <div
        class="center mt-10 mb-40 pt-10 pb-40 api-log-error"
        v-if="apiLogs.error && apiLogs.errorMsg.length"
      >
        {{ apiLogs.errorMsg }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "overview",
  components: {
    loadingEven: require("../even/loading").default,
  },
  async created() {
    await this.$store.dispatch("integrations/getApiKeys");
    await this.$store.dispatch("integrations/getApiLogs");
    this.pageCurrentLogChange(1);
  },
  computed: {
    apiKeys() {
      return this.$store.getters["integrations/apiKeys"];
    },
    apiKeyDev() {
      return this.$store.getters["integrations/apiKeyDev"];
    },
    apiKeyProd() {
      return this.$store.getters["integrations/apiKeyProd"];
    },
    apiLogs() {
      return this.$store.getters["integrations/apiLogs"];
    },
  },
  data() {
    return {
      test: "test",
      loggingData: {
        page: 1,
        results: [],
        data: [
          {
            date: "March 29, 2020",
            time: "2:31 PM",
            operation: "Happily Recognition - Create Recognition",
            status: "Success",
            deployment: "Development",
          },
          {
            date: "March 29, 2020",
            time: "2:22 PM",
            operation: "Happily Recognition - Create Recognition",
            status: "Failed",
            deployment: "-",
          },
          {
            date: "March 29, 2020",
            time: "2:14 PM",
            operation: "Happily Recognition - Create Recognition",
            status: "Success",
            deployment: "Production",
          },
          {
            date: "March 29, 2020",
            time: "2:13 PM",
            operation: "Happily Recognition - Create Recognition",
            status: "Success",
            deployment: "Production",
          },
          {
            date: "March 29, 2020",
            time: "2:7 PM",
            operation: "Happily Recognition - Create Recognition",
            status: "Success",
            deployment: "Development",
          },
          {
            date: "March 29, 2020",
            time: "2:5 PM",
            operation: "Happily Recognition - Create Recognition",
            status: "Success",
            deployment: "Production",
          },
          {
            date: "March 29, 2020",
            time: "1:10 PM",
            operation: "Happily Recognition - Create Recognition",
            status: "Success",
            deployment: "Production",
          },
          {
            date: "March 29, 2020",
            time: "1:04 PM",
            operation: "Happily Recognition - Create Recognition",
            status: "Failed",
            deployment: "-",
          },
          {
            date: "March 29, 2020",
            time: "1:04 PM",
            operation: "Happily Recognition - Create Recognition",
            status: "Failed",
            deployment: "-",
          },
          {
            date: "March 29, 2020",
            time: "1:03 PM",
            operation: "Happily Recognition - Create Recognition",
            status: "Success",
            deployment: "Development",
          },
          {
            date: "March 29, 2020",
            time: "1:03 PM",
            operation: "Happily Recognition - Create Recognition",
            status: "Success",
            deployment: "Production",
          },
          {
            date: "March 29, 2020",
            time: "1:02 PM",
            operation: "Happily Recognition - Create Recognition",
            status: "Success",
            deployment: "Production",
          },
        ],
      },
      production: {
        generate: false,
        token: "",
        mockTaken: [],
        showingStatus: false,
      },
    };
  },
  mounted() {
    this.hideApiKeyProd();
    // this.pageCurrentLogChange(1);
  },
  methods: {
    /* Development */

    async createApiKeyDev() {
      await this.$store.dispatch("integrations/createApiKey", "dev");
      this.hideApiKeyDev();
      this.$message({
        message: "Token Created",
        type: "success",
      });
    },
    hideApiKeyDev() {
      if (!this.apiKeyDev.token) return;
      let taken = [];
      for (let i = 0; i < this.apiKeyDev.token.length; i++) {
        taken.push(i);
      }
      this.apiKeyDev.mockTaken = taken;
    },
    copyApiKeyDev() {
      const clipboardData = window.clipboardData || navigator.clipboard;
      clipboardData.writeText(this.apiKeyDev.token);
      this.$message({
        message: "Copy Token to clipboard",
        type: "success",
      });
    },
    async removeApiKeyDev() {
      await this.$store.dispatch("integrations/removeApiKey", "dev");
      this.$message({
        message: "Token Removed",
        type: "warning",
      });
    },

    /* Production */

    async createApiKeyProd() {
      await this.$store.dispatch("integrations/createApiKey", "prod");
      this.hideApiKeyProd();
      this.$message({
        message: "Token Created",
        type: "success",
      });
    },
    hideApiKeyProd() {
      if (!this.apiKeyProd.token) return;
      let taken = [];
      for (let i = 0; i < this.apiKeyProd.token.length; i++) {
        taken.push(i);
      }
      this.apiKeyProd.mockTaken = taken;
    },
    copyApiKeyProd() {
      const clipboardData = window.clipboardData || navigator.clipboard;
      clipboardData.writeText(this.apiKeyProd.token);
      this.$message({
        message: "Copy Token to clipboard",
        type: "success",
      });
    },
    async removeApiKeyProd() {
      await this.$store.dispatch("integrations/removeApiKey", "prod");
      this.$message({
        message: "Token Removed",
        type: "warning",
      });
    },

    pageCurrentLogChange(value) {
      this.$store.dispatch("integrations/pageCurrentLogChange", value);
    },
    gotoApiDoc() {
      // let url = "https://developer.happily.ai";
      let url = "https://happily.ai/api";
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.card-integration {
  display: grid;
  grid-template-columns: 64px auto 113px;
  margin: 16px 0;
}
.logo-integratioin {
  border-radius: 6px;
  width: 64px;
  height: 64px;
}
.sub-description {
  color: #3b3b3b;
  font-size: 14px;
}
.text-oeration {
  background-color: #f0f0f0;
  border-radius: 6px;
  padding: 12px 12px 10px;
  margin-right: 12px;
}
.text-oeration.red {
  background-color: #d2d2d2;
}
.input-gray,
.btn-api,
.token-input {
  height: 52px;
  padding: 0 16px;
}
.btn-api {
  background-color: #32c2d5;
  min-width: 100px;
  border-radius: 8px;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  transition: 0.2s;
  cursor: pointer;
  &:hover {
    background-color: #1a9eaf;
  }
}
.token-input,
.input-gray {
  background-color: #f7f7f7;
  border: 1px solid #c7c7c7;
  border-radius: 4px;
  transition: 0.2s;
  &:hover {
    background-color: #eeeeee;
  }
}
.token-input {
  width: calc(572px - 32px);
}
.input-gray {
  width: 52px;
  padding: 0px;
}
</style>

<style lang="scss">
#log_table_api .el-table td {
  padding: 6px 0;
}
.api-log-error {
  color: #f56c6c;
}
</style>


